import { computed, inject, Injectable } from '@angular/core';

import { AdminModeService } from '../admin-mode/admin-mode.service';
import { RoleGroup } from '../roles';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class ReadonlyService {
  private readonly userService = inject(UserService);
  private readonly adminModeService = inject(AdminModeService);

  readonly readonly = computed(() => {
    if (this.adminModeService.isAdminModeActive()) {
      // Write functionality should be disabled if the admin mode is enabled and the current user does not have write rights or
      // no distribution partner nr is provided
      return !this.adminModeService.hasAdminWritePermissions();
    } else {
      // Write functionality should be disabled if user has no write permissions.
      return !this.userService.userIsAllowed(RoleGroup.CDF_WRITE);
    }
  });
}
